import { render, staticRenderFns } from "./buyShebeiInfo.vue?vue&type=template&id=24a1c8b6&scoped=true&"
import script from "./buyShebeiInfo.vue?vue&type=script&lang=js&"
export * from "./buyShebeiInfo.vue?vue&type=script&lang=js&"
import style0 from "./buyShebeiInfo.vue?vue&type=style&index=0&id=24a1c8b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a1c8b6",
  null
  
)

export default component.exports